webpackJsonp([132207355946902],{

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _input = __webpack_require__(279);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_input).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = function Input(_ref) {
	  var label = _ref.label,
	      placeholder = _ref.placeholder,
	      type = _ref.type,
	      name = _ref.name,
	      required = _ref.required;
	
	  var input = _react2.default.createElement('input', {
	    className: 'h40 w-100 br2 ba b--moon-gray input-reset outline-0 pv2 ph3 sans-serif focus-b--green',
	    type: type,
	    name: name,
	    placeholder: placeholder,
	    required: required
	  });
	
	  if (label) {
	    return _react2.default.createElement(
	      'label',
	      { className: 'mb3' },
	      _react2.default.createElement(
	        'span',
	        { className: 'mb1 db' },
	        label
	      ),
	      input
	    );
	  }
	
	  return input;
	};
	
	Input.propTypes = {
	  label: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  required: _propTypes2.default.bool
	};
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionCasting = __webpack_require__(302);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionCasting).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _sectionContactForm = __webpack_require__(303);
	
	var _sectionContactForm2 = _interopRequireDefault(_sectionContactForm);
	
	__webpack_require__(454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionCasting = function SectionCasting(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray;
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      gray: gray,
	      title: 'Casting Tools',
	      subtitle: 'Better results in less time',
	      topText: 'Next Level'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex items-center justify-between mb6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-22 mw184' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.castingImg1.sizes, alt: 'Casting Tools' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-56' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.castingImg2.sizes, alt: 'Casting Tools' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-22 mw184' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.castingImg3.sizes, alt: 'Casting Tools' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mw460 w-100 center' },
	      _react2.default.createElement(
	        'p',
	        { className: 'mb3 tc' },
	        'Contact us for premium partnership'
	      ),
	      _react2.default.createElement(_sectionContactForm2.default, { justEmail: true })
	    )
	  );
	};
	
	SectionCasting.propTypes = {
	  data: _propTypes2.default.object,
	  gray: _propTypes2.default.bool
	};
	
	exports.default = SectionCasting;
	module.exports = exports['default'];

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionContactForm = __webpack_require__(304);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionContactForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _input = __webpack_require__(278);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _textarea = __webpack_require__(340);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _button = __webpack_require__(37);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionContactForm = function SectionContactForm(_ref) {
	  var justEmail = _ref.justEmail;
	
	  if (justEmail) {
	    return _react2.default.createElement(
	      'form',
	      {
	        name: 'contact',
	        action: 'https://formspree.io/jari@choicely.com',
	        method: 'POST',
	        className: 'flex items-center justify-center mb0'
	      },
	      _react2.default.createElement(_input2.default, {
	        placeholder: 'Enter your email',
	        type: 'email',
	        name: 'email',
	        required: true
	      }),
	      _react2.default.createElement(
	        _button2.default,
	        { type: 'submit', color: 'green', className: 'ml1' },
	        'Send'
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Talk to us!',
	      subtitle: 'Need some help? Interested in partnerships? We would love to help you. '
	    },
	    _react2.default.createElement(
	      'form',
	      {
	        className: 'mw330 flex flex-column center mb0',
	        name: 'contact',
	        action: 'https://formspree.io/jari@choicely.com',
	        method: 'POST'
	      },
	      _react2.default.createElement(_input2.default, { label: 'Name', type: 'text', name: 'name', required: true }),
	      _react2.default.createElement(_input2.default, { label: 'E-mail Adress', type: 'email', name: 'email', required: true }),
	      _react2.default.createElement(_textarea2.default, { label: 'Message', name: 'message', rows: '7', required: true }),
	      _react2.default.createElement(
	        _button2.default,
	        { type: 'submit', color: 'blue' },
	        'Send Message'
	      )
	    )
	  );
	};
	
	SectionContactForm.propTypes = {
	  justEmail: _propTypes2.default.bool
	};
	
	exports.default = SectionContactForm;
	module.exports = exports['default'];

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img3.afe813b8.png";

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionIntegration = __webpack_require__(321);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionIntegration).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionIntegrationSlide = function SectionIntegrationSlide(_ref) {
	  var img = _ref.img,
	      text = _ref.text,
	      small = _ref.small;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)({
	        'w-50 w-third-m mb3 mb0-m ph2 flex': true,
	        'flex-column items-center justify-end': true
	      }) },
	    _react2.default.createElement('img', {
	      className: (0, _classnames2.default)({
	        'mb3 w-100': true,
	        'mw180': small,
	        'mw240': !small
	      }),
	      src: img,
	      alt: text
	    }),
	    _react2.default.createElement(
	      'p',
	      { className: 'f13 ttu mb0 min-h30 first-letter gray' },
	      text
	    )
	  );
	};
	
	SectionIntegrationSlide.propTypes = {
	  text: _propTypes2.default.string,
	  small: _propTypes2.default.bool
	};
	
	exports.default = SectionIntegrationSlide;
	module.exports = exports['default'];

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _sectionIntegrationSlide = __webpack_require__(320);
	
	var _sectionIntegrationSlide2 = _interopRequireDefault(_sectionIntegrationSlide);
	
	var _img = __webpack_require__(642);
	
	var _img2 = _interopRequireDefault(_img);
	
	var _img3 = __webpack_require__(643);
	
	var _img4 = _interopRequireDefault(_img3);
	
	var _img5 = __webpack_require__(644);
	
	var _img6 = _interopRequireDefault(_img5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionIntegration = function SectionIntegration(_ref) {
	  var gray = _ref.gray;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Integration',
	      subtitle: 'Share your content to media partners on web, apps, social, TV & stream',
	      gray: gray
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-wrap mh--2' },
	      _react2.default.createElement(_sectionIntegrationSlide2.default, {
	        img: _img2.default,
	        text: '1 create events on choicely.com',
	        small: true
	      }),
	      _react2.default.createElement(_sectionIntegrationSlide2.default, {
	        img: _img4.default,
	        text: '2 integrate on your websites & native apps'
	      }),
	      _react2.default.createElement(_sectionIntegrationSlide2.default, {
	        img: _img6.default,
	        text: '3 share to social media, show live results on TV'
	      })
	    )
	  );
	};
	
	SectionIntegration.propTypes = {
	  gray: _propTypes2.default.bool
	};
	
	exports.default = SectionIntegration;
	module.exports = exports['default'];

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionMeaningful = __webpack_require__(325);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionMeaningful).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	__webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionMeaningfulData = function SectionMeaningfulData(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Meaningful data',
	      subtitle: 'View results by demographics, heat maps & more',
	      gray: gray
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex items-center flex-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100 w-42-m' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: data.meaningfulImg1.sizes,
	          alt: 'Meaningful data, View results by demographics, heat maps & more'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100 w-58-m' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: data.meaningfulImg2.sizes,
	          alt: 'Meaningful data, View results by demographics, heat maps & more'
	        })
	      )
	    )
	  );
	};
	
	SectionMeaningfulData.propTypes = {
	  data: _propTypes2.default.object,
	  gray: _propTypes2.default.bool
	};
	
	exports.default = SectionMeaningfulData;
	module.exports = exports['default'];

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/outProductsCasting.3ba81697.jpg";

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/outProductsRating.f7b117db.jpg";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/outProductsVoting.c6de8472.jpg";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionOurProducts = __webpack_require__(329);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionOurProducts).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainSectionLayout = __webpack_require__(29);
	
	var _mainSectionLayout2 = _interopRequireDefault(_mainSectionLayout);
	
	var _pageTopBar = __webpack_require__(30);
	
	var _pageTopBar2 = _interopRequireDefault(_pageTopBar);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _getStartedButton = __webpack_require__(56);
	
	var _getStartedButton2 = _interopRequireDefault(_getStartedButton);
	
	var _common = __webpack_require__(31);
	
	var _outProductsCasting = __webpack_require__(645);
	
	var _outProductsCasting2 = _interopRequireDefault(_outProductsCasting);
	
	var _outProductsVoting = __webpack_require__(647);
	
	var _outProductsVoting2 = _interopRequireDefault(_outProductsVoting);
	
	var _outProductsRating = __webpack_require__(646);
	
	var _outProductsRating2 = _interopRequireDefault(_outProductsRating);
	
	__webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionOurProducts = function SectionOurProducts() {
	  return _react2.default.createElement(
	    _pageTopBar2.default,
	    { iconName: 'crown', text: 'Our products' },
	    _react2.default.createElement(
	      _mainSectionLayout2.default,
	      {
	        noLogo: true,
	        title: 'Our products',
	        about: 'Grow your audience and revenue. Share content to beauty fans across the globe. We have developed the most advanced digital tools for you in close cooperation with beauty pageants for the past 4 years.'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex justify-between mb7' },
	        _react2.default.createElement(ImageItem, {
	          imgSrc: _outProductsCasting2.default,
	          text: 'Casting',
	          iconName: 'masks'
	        }),
	        _react2.default.createElement(ImageItem, {
	          imgSrc: _outProductsVoting2.default,
	          text: 'Voting',
	          iconName: 'voting'
	        }),
	        _react2.default.createElement(ImageItem, {
	          imgSrc: _outProductsRating2.default,
	          text: 'Judge Rating',
	          iconName: 'rating'
	        })
	      ),
	      _react2.default.createElement(_getStartedButton2.default, null)
	    )
	  );
	};
	
	var ImageItem = function ImageItem(_ref) {
	  var imgSrc = _ref.imgSrc,
	      iconName = _ref.iconName,
	      text = _ref.text;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ph2' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mb2 mb3-m min-h116' },
	      _react2.default.createElement('img', { src: imgSrc, alt: '', className: 'mh300' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex items-center' },
	      _react2.default.createElement(_icons2.default, { icon: iconName, height: _common.isMobile ? '14px' : '30px', className: 'mr2' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'f12 f9-m f6-l fw5' },
	        text
	      )
	    )
	  );
	};
	
	exports.default = SectionOurProducts;
	module.exports = exports['default'];

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionRating = __webpack_require__(331);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionRating).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	__webpack_require__(465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionRatingBeauty = function SectionRatingBeauty(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Rating tools',
	      subtitle: 'for judge rating',
	      topText: 'Advanced',
	      topGreen: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-wrap items-center justify-center mb6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-37 mw318' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.ratingImg1.sizes, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-23 mw196' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.ratingImg2.sizes, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-21 mw180' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.ratingImg3.sizes, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-19 mw158' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.ratingImg4.sizes, alt: '' })
	      )
	    )
	  );
	};
	
	exports.default = SectionRatingBeauty;
	module.exports = exports['default'];

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionRevenue = __webpack_require__(101);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionRevenue).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	__webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionRevenueImg = function SectionRevenueImg(_ref) {
	  var sizes = _ref.sizes,
	      icon = _ref.icon,
	      iconText = _ref.iconText,
	      number = _ref.number,
	      numberText = _ref.numberText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100 w-50-m w-25-l ph3 mb4 mb0-l' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw186 center' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes, alt: '', className: 'mb4' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mb2 pa2 w96 min-h96 ba b--moon-gray br2 center flex flex-column items-center justify-center' },
	        _react2.default.createElement(_icons2.default, { icon: icon, size: '36px', className: 'mb2' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'mv0 f13 tc' },
	          iconText
	        )
	      ),
	      !!number && _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mr2 flex-shrink-0 w50 h50 bg-black white pa2 br-100 flex items-center justify-center' },
	          number
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'mv0 f13 mv1' },
	          numberText
	        )
	      )
	    )
	  );
	};
	
	SectionRevenueImg.propTypes = {
	  sizes: _propTypes2.default.object
	};
	
	exports.default = SectionRevenueImg;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	var _sectionRevenueImg = __webpack_require__(100);
	
	var _sectionRevenueImg2 = _interopRequireDefault(_sectionRevenueImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionRevenue = function SectionRevenue(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray,
	      isSimple = _ref.isSimple;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'New Revenue Streams',
	      subtitle: isSimple ? '' : 'Let consumers buy extra votes & bring sponsors to your votes',
	      topGreen: true,
	      gray: gray
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-wrap justify-center mh--3 mb4' },
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg1.sizes,
	        icon: 'three-stars',
	        iconText: 'Paid votes',
	        number: isSimple ? '' : _react2.default.createElement(_icons2.default, { icon: 'starFilled', size: '60%' }),
	        numberText: 'Let your audience buy extra vote packages and share your contest'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg2.sizes,
	        icon: 'batman',
	        iconText: 'Branded Buttons',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '1'
	        ),
	        numberText: 'Brand the voting button let your audience vote by touching your brand'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg3.sizes,
	        icon: 'play-circle',
	        iconText: 'Video ads',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '2'
	        ),
	        numberText: 'Then your audience will automatically see a 15sec commercial'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg4.sizes,
	        icon: 'lead-capture',
	        iconText: 'Lead Capture',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '3'
	        ),
	        numberText: 'While watching the commercial they can fill their contact info to get discounts, win prizes or participate in campaigns'
	      })
	    ),
	    isSimple && _react2.default.createElement(
	      'div',
	      { className: 'mw800 center' },
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'Due to our experience and expertise in the beauty pageant industry, we are specialized in helping our clients with creating new digital revenue streams for their businesses.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'As we all know, many beauty pageants have large audiences but have yet been unsuccessful to monetize their audience. We have helped hundreds of organisers to successfully create new revenue for their businesses from scratch.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'Our tailormade turnkey solutions like paid votes, video ads, lead capture and branded buttons help your organisation to generate totally new revenue for you.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'To get access to our readymade toolkit is easy. Just contact us and we can set up tailored made solutions according to your needs. All features can be live in your digital environment in hours after we have agreed together the best solution for your beauty pageant.'
	      )
	    )
	  );
	};
	
	SectionRevenue.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = SectionRevenue;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coins_green.cefa89a5.svg";

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coins_yellow.3e6e0de9.svg";

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionVoting = __webpack_require__(335);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionVoting).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _threeImages = __webpack_require__(342);
	
	var _threeImages2 = _interopRequireDefault(_threeImages);
	
	var _getStartedButton = __webpack_require__(56);
	
	var _getStartedButton2 = _interopRequireDefault(_getStartedButton);
	
	var _coins_green = __webpack_require__(648);
	
	var _coins_green2 = _interopRequireDefault(_coins_green);
	
	var _coins_yellow = __webpack_require__(649);
	
	var _coins_yellow2 = _interopRequireDefault(_coins_yellow);
	
	__webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionVoting = function SectionVoting(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      gray: gray,
	      title: 'Voting tools',
	      subtitle: 'for people\xB4s choice voting',
	      topText: 'Advanced',
	      topGreen: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'relative mw560 center mb6' },
	      _react2.default.createElement(_threeImages2.default, {
	        left: data.votingImg1.sizes,
	        center: data.votingImg2.sizes,
	        right: data.votingImg3.sizes
	      }),
	      _react2.default.createElement('img', {
	        src: _coins_yellow2.default,
	        className: 'absolute w128 bottom-0 mv0 z-3 left-0 left--2-l',
	        alt: 'coins'
	      }),
	      _react2.default.createElement('img', {
	        src: _coins_green2.default,
	        className: 'absolute w128 bottom-0 mv0 z-3 right-0 right--2-l',
	        alt: 'coins'
	      })
	    ),
	    _react2.default.createElement(_getStartedButton2.default, null)
	  );
	};
	SectionVoting.propTypes = {
	  data: _propTypes2.default.object,
	  gray: _propTypes2.default.bool
	};
	
	exports.default = SectionVoting;
	module.exports = exports['default'];

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textarea = __webpack_require__(341);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textarea).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Textarea = function Textarea(_ref) {
	  var label = _ref.label,
	      placeholder = _ref.placeholder,
	      rows = _ref.rows,
	      name = _ref.name,
	      required = _ref.required;
	
	  var textarea = _react2.default.createElement('textarea', {
	    className: 'w-100 br2 ba b--moon-gray outline-0 pa3 sans-serif focus-b--green',
	    name: name,
	    rows: rows,
	    required: required,
	    placeholder: placeholder
	  });
	
	  if (label) {
	    return _react2.default.createElement(
	      'label',
	      { className: 'mb3' },
	      _react2.default.createElement(
	        'span',
	        { className: 'mb1 db' },
	        label
	      ),
	      textarea
	    );
	  }
	
	  return textarea;
	};
	
	Textarea.propTypes = {
	  label: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  rows: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  required: _propTypes2.default.bool
	};
	
	exports.default = Textarea;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _threeImages = __webpack_require__(343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_threeImages).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThreeImages = function ThreeImages(_ref) {
	  var left = _ref.left,
	      center = _ref.center,
	      right = _ref.right,
	      notCentered = _ref.notCentered;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)({
	        'w-100 mw560': true,
	        center: !notCentered
	      })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex items-center mh--2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-32 ph2' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: left, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-36 ph2' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: center, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'w-32 ph2' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: right, alt: '' })
	      )
	    )
	  );
	};
	
	ThreeImages.propTypes = {
	  left: _propTypes2.default.object,
	  center: _propTypes2.default.object,
	  right: _propTypes2.default.object
	};
	
	exports.default = ThreeImages;
	module.exports = exports['default'];

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our_products.499cb5ab.png";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sectionOurProducts = __webpack_require__(328);
	
	var _sectionOurProducts2 = _interopRequireDefault(_sectionOurProducts);
	
	var _sectionVoting = __webpack_require__(334);
	
	var _sectionVoting2 = _interopRequireDefault(_sectionVoting);
	
	var _sectionRating = __webpack_require__(330);
	
	var _sectionRating2 = _interopRequireDefault(_sectionRating);
	
	var _sectionCasting = __webpack_require__(301);
	
	var _sectionCasting2 = _interopRequireDefault(_sectionCasting);
	
	var _sectionRevenue = __webpack_require__(99);
	
	var _sectionRevenue2 = _interopRequireDefault(_sectionRevenue);
	
	var _sectionMeaningful = __webpack_require__(324);
	
	var _sectionMeaningful2 = _interopRequireDefault(_sectionMeaningful);
	
	var _sectionIntegration = __webpack_require__(319);
	
	var _sectionIntegration2 = _interopRequireDefault(_sectionIntegration);
	
	var _our_products = __webpack_require__(659);
	
	var _our_products2 = _interopRequireDefault(_our_products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OurProducts = function (_Component) {
	  _inherits(OurProducts, _Component);
	
	  function OurProducts() {
	    _classCallCheck(this, OurProducts);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OurProducts.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Our products'
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Our products' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Grow your audience and revenue. Share content to beauty fans across the globe. We have developed the most advanced digital tools for you in close cooperation with beauty pageants for the past 4 years.' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://nextmiss.com' + _our_products2.default }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://nextmiss.com/our_products/' }),
	        _react2.default.createElement('meta', { property: 'og:image:alt', content: 'Our products - Next Miss' })
	      ),
	      _react2.default.createElement(_sectionOurProducts2.default, null),
	      _react2.default.createElement(_sectionVoting2.default, { data: data, gray: true }),
	      _react2.default.createElement(_sectionRating2.default, { data: data }),
	      _react2.default.createElement(_sectionCasting2.default, { data: data, gray: true }),
	      _react2.default.createElement(_sectionRevenue2.default, { data: data }),
	      _react2.default.createElement(_sectionMeaningful2.default, { data: data, gray: true }),
	      _react2.default.createElement(_sectionIntegration2.default, null)
	    );
	  };
	
	  return OurProducts;
	}(_react.Component);
	
	exports.default = OurProducts;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-our-products-js-924693901463e580ac42.js